(function () {
  'use strict';

  angular
    .module('app.form', [])

    /* @ngInject */
    .controller('contactController', ["$scope", "$element", "LoadService", function ($scope, $element, LoadService) {
      var ctrl = this;
      ctrl.js = $element.data('js');
      LoadService.getService('AsyncFormService', { ctrl: ctrl, scope: $scope }, 'initContact');
    }])

    /* @ngInject */
    .controller('catalogRequestController', ["$scope", "$element", "LoadService", function ($scope, $element, LoadService) {
      var ctrl = this;
      ctrl.js = $element.data('js');
      LoadService.getService('AsyncFormService', { ctrl: ctrl, scope: $scope }, 'initCatalogRequest');
    }]);
})();
